/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MeiTiChanPinZhuangTaiGengXinDTO,
  MeiTiZiYuanBaoMingChaXunDTO,
  MeiTiZiYuanChaXunDTO,
  MeiTiZiYuanChuangJianDTO,
  MeiTiZiYuanGengXinDTO,
  ResponseApiInt,
  ResponseApiIPageMeiTiZiYuanLieBiaoXiangYingDTO,
  ResponseApiListString1,
  ResponseApiMapStringString,
  ResponseApiMeiTiZiYuanLieBiaoXiangYingDTO,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class MeiTiZiYuanGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name CategoryListUsingGet
   * @summary 资源类型列表
   * @request GET:/dsp-admin/api/publisher/product/category/list
   * @secure
   */
  categoryListUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiMapStringString, void>({
      path: `/dsp-admin/api/publisher/product/category/list`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name CreatePublisherProductUsingPost
   * @summary 创建媒体资源
   * @request POST:/dsp-admin/api/publisher/product/create
   * @secure
   */
  createPublisherProductUsingPost = (
    createDTO: MeiTiZiYuanChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiInt, void>({
      path: `/dsp-admin/api/publisher/product/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name PublisherProductListUsingPost
   * @summary 分页查询媒体资源列表
   * @request POST:/dsp-admin/api/publisher/product/list
   * @secure
   */
  publisherProductListUsingPost = (
    queryDTO: MeiTiZiYuanChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageMeiTiZiYuanLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/product/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name PublisherProductPkgListUsingPost
   * @summary 查询媒体资源包名列表
   * @request POST:/dsp-admin/api/publisher/product/pkg/list
   * @secure
   */
  publisherProductPkgListUsingPost = (
    queryDTO: MeiTiZiYuanBaoMingChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListString1, void>({
      path: `/dsp-admin/api/publisher/product/pkg/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name GetPublisherProductByIdUsingGet
   * @summary 获取媒体资源信息
   * @request GET:/dsp-admin/api/publisher/product/{id}
   * @secure
   */
  getPublisherProductByIdUsingGet = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiMeiTiZiYuanLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/product/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name UpdatePublisherProductUsingPut
   * @summary 更新媒体资源
   * @request PUT:/dsp-admin/api/publisher/product/{id}
   * @secure
   */
  updatePublisherProductUsingPut = (
    updateDTO: MeiTiZiYuanGengXinDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiInt, void>({
      path: `/dsp-admin/api/publisher/product/${id}`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name DeletePublisherProductUsingDelete
   * @summary 删除媒体资源
   * @request DELETE:/dsp-admin/api/publisher/product/{id}
   * @secure
   */
  deletePublisherProductUsingDelete = (
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/publisher/product/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiZiYuanGuanLi
   * @name UpdatePublisherProductStatusUsingPut
   * @summary 仅更新媒体资源状态
   * @request PUT:/dsp-admin/api/publisher/product/{id}/status
   * @secure
   */
  updatePublisherProductStatusUsingPut = (
    statusUpdateDTO: MeiTiChanPinZhuangTaiGengXinDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/publisher/product/${id}/status`,
      method: "PUT",
      body: statusUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new MeiTiZiYuanGuanLi();
